import { defineMessages } from 'react-intl-next';

export default defineMessages({
	loadingMessage: {
		id: 'smart-creation.preview.loading.message',
		defaultMessage: 'Creating your spec...',
		description:
			'Loading message explaining to the user that Rovo is creating their requested content.',
	},
});
